import React, { PropTypes } from 'react';
import LatLngInput from '../Common/LatLngInput';
import PointLabelInput from '../Common/PointLabelInput';
import LightBox from '../Common/LightBox';
import { validateLat, validateLng } from '../../businessLogic/util';
import ReactTooltip from 'react-tooltip';
import { ROOT } from '../../constants/root';
import AdicionarImagemAoPonto from './AdicionarImagemAoPonto';
import { prettyConfirm } from '../Common/Dialog';

export default class Point extends React.Component {

	constructor(props) {
		super(props);
		this.divImagePointList = 0;
		this.state = { isOpen: false, url: "", isShowingMore: false, listHeight: null };

	}

	deleteConfirm(title, message, yesCallback) {
		prettyConfirm(title, message, "Deletar", "Cancelar", yesCallback);
	}

	getModalStyle() {
		return {
			overlay: { backgroundColor: 'rgba(255, 255, 255, 0.75)' },
			content: { margin: "50px", display: "flex" }
		};
	}

	getRemovePointIcon() {
		const { point, removePoint, removeSavedPoint, index } = this.props;
		return point.savedImg.length === 0 && point.img.length === 0
			? <i className="fa fa-times pointer" data-tip="Remover ponto" onClick={
				() => {
					
					if (point.id) {
						const title = "Deseja deletar esse ponto?";
						const message = "Esse procedimento não pode ser revertido!";
						const yesCallback = () => removeSavedPoint(point.id); 
						
						this.deleteConfirm(title, message, yesCallback);
					} else {
						removePoint(index);
					}

				}
			} />
			: <i className="fa fa-times" style={{cursor: "not-allowed", color: "#777"}}
				data-tip="Remova as imagens associadas antes de excluir o ponto!" />;
	}

	getShowLess() {
		if (this.props.point.img.length > 0) return null;
		if (this.props.isNewPoint) return "";
		if (this.divCustomLocalBox > this.divImagePointList) return "";

		return this.state.isShowingMore ? "" : "show-more-or-less";
	}

	showMoreOrLessWall() {
		if (this.props.point.img.length > 0) return null;
		if (this.props.isNewPoint) return null;
		if (this.divCustomLocalBox > this.divImagePointList) return null;
		
		const moreOrLess = this.state.isShowingMore ? 'less' : 'more';
		if (this.divImagePointList.clientHeight < 500) return;

		return (
			<div className={`show-more-or-less-wall ${moreOrLess}`}>

				{this.state.isShowingMore 
				? <button onClick={
					() => this.setState({isShowingMore: !this.state.isShowingMore})
				}>Mostrar menos pontos</button> 
				: <button onClick={
					() => this.setState({isShowingMore: !this.state.isShowingMore})
				}>Mostrar mais pontos</button>}
			</div>
		);
	}

	render () {	
		const { index, setLat, setLng, point, 
				setPointSrc, setPointCaption, 
				removePointImage, removeSavedPointImage,
				setSavedPointCaption } = this.props;		
		return (
			<div className={`custom-local-box`} 
				ref={(divCustomLocalBox) => this.divCustomLocalBox = divCustomLocalBox}
			>	

				<div className='remove-point' >
					<span>{this.getRemovePointIcon()}</span>
					<ReactTooltip />
				</div>

				<div className='latlong'>
					<div className="lat">
						<LatLngInput
							label="Latitude"
							value={point.lat}
							index={index}
							disabled={point.savedImg.length > 0}
							validation={validateLat}
							action={setLat}
							helpText="Entre -90 e 90" 
						/>
					</div>

					<div className="long">
						<LatLngInput
							label="Longitude"
							value={point.lng}
							index={index}
							disabled={point.savedImg.length > 0}
							validation={validateLng}
							action={setLng}
							helpText="Entre -180 e 180" 
						/>
					</div>	
				</div>

				<PointLabelInput 
					name="Label do ponto"
					value={point.label}
					index={index}
					action={this.props.setPointLabel} 
				/>
				
				<div className={`image-point-list ${this.getShowLess()}`}
					ref={(divImagePointList) => this.divImagePointList = divImagePointList}	
				>
					{point.savedImg.map((i, j) =>
						<div key={j} className="saved image-point">
							<div className='left'>
								<div className='filename'>
									<a style={{cursor: "pointer"}} 
										className="filename"
										data-tip={i.filename + " (Clique para visualizar)"}
										onClick={() => this.setState({isOpen: true, url: `${ROOT}/picture/${i.src}/`})}>
										
										<i className="fa fa-image" data-tip="Clique para visualizar a imagem" />{i.filename}
									</a>
								</div>
								
								<input
									className='image-legend' 
									type="text" 
									placeholder="Legenda da imagem" 
									value={i.caption} 
									onChange={(e) => setSavedPointCaption(index, j, e.target.value)} 
								/>
								
								{i.datetime 
								? <input 
									className='image-datetime'
									type="text"
									value={i.datetime}
									disabled 
								/> : null
								}
							</div>
							
							<div className='right'>
								<i 
									className="far fa-trash-alt pointer" 
									data-tip="Remover Imagem" 
									onClick={() => {
										const title = "Deseja deletar essa imagem? ";
										const message = "Esse procedimento não pode ser revertido!";
										const yesCallback = () => removeSavedPointImage(i.src);
										
										this.deleteConfirm(title, message, yesCallback);
									}}  
								/>
								<ReactTooltip />
							</div>
						</div>
					)}

					{point.img.map((i, j) =>
						<div className='new image-point' key={j} >
							<div className='left'>
								<input 
									type="file" 
									accept="image/*"
									id={`files-${index}-${j}`}
									className="load-image-input hidden"								
									onChange={(e) => setPointSrc(index, j, e.target.files[0])} />

								<label style={{cursor: "pointer"}} htmlFor={`files-${index}-${j}`}>
									<span>{i.src === null ? "Carregar imagem..." : i.src.name}</span>
								</label>	

								<input 
								className='image-legend'
								type="text" 
								placeholder="Legenda da imagem" 
								value={i.caption} 
								onChange={(e) => setPointCaption(index, j, e.target.value)} />

								{i.datetime 
									? <input 
										className='image-datetime'
										type="text"
										value={i.datetime}
										disabled 
									></input> : null
								}	
							</div>
							<div className='right'>
								<i className="far fa-trash-alt pointer" 
									data-tip="Remover Imagem" onClick={() => removePointImage(index, j)} />
								<ReactTooltip />
							</div>
						</div>
					)}
				</div>

				<AdicionarImagemAoPonto 
					targetPointIndex={index}
					targetPoint={point}
					addPointImageWithSrc={this.props.addPointImageWithSrc}
					checkExistance={this.props.checkExistance}
					
				/>
	
				<LightBox 
					onClose={() => this.setState({isOpen: false, url: ""})} 
					isOpen={this.state.isOpen}
					style={this.getModalStyle()}
				>
					<div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<img src={this.state.url} 
							style={{ maxHeight: '100%', maxWidth: '100%' }} />
					</div>
				</LightBox>	

				{this.showMoreOrLessWall()}			
			</div>
		);
	}
}

Point.propTypes = {
	isNewPoint: PropTypes.bool,
	point: PropTypes.object.isRequired,
	index: PropTypes.number.isRequired,
	removePoint: PropTypes.func.isRequired,
	addPointImage: PropTypes.func.isRequired,
	addPointImageWithSrc: PropTypes.func.isRequired,
	removePointImage: PropTypes.func.isRequired,
	removeSavedPoint: PropTypes.func.isRequired,
	removeSavedPointImage: PropTypes.func.isRequired,
	setPointSrc: PropTypes.func.isRequired,
	setPointCaption: PropTypes.func.isRequired,
	setPointLabel: PropTypes.func.isRequired,
	setSavedPointCaption: PropTypes.func.isRequired,
	setLat: PropTypes.func.isRequired,
	setLng: PropTypes.func.isRequired,
	checkExistance: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Documents/Point.js